/*!
 * 1DS JS SDK Properties plugin, 3.0.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Sdk.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { CoreUtils, cookieAvailable, setCookie, getCookie, deleteCookie, } from "@ms/1ds-core-js";
var DEVICE_ID_COOKIE = "MicrosoftApplicationsTelemetryDeviceId";
var Sdk = /** @class */ (function () {
    function Sdk(coreConfig) {
        this._sequenceId = 0;
        this._propertyStorage = coreConfig.propertyStorageOverride;
        // Start sequence
        this.seq = this._sequenceId;
        this.epoch = (new Date()).getTime().toString();
        // Only collect device id if it can be stored
        if (!coreConfig.disableCookiesUsage && cookieAvailable() || this._propertyStorage) {
            var deviceId = this._getData(DEVICE_ID_COOKIE);
            if (!deviceId) {
                deviceId = CoreUtils.newGuid();
            }
            this._saveData(DEVICE_ID_COOKIE, deviceId);
            this.installId = deviceId;
        }
        else {
            deleteCookie(DEVICE_ID_COOKIE);
        }
    }
    // Get seq value
    Sdk.prototype.getSequenceId = function () {
        return ++this._sequenceId;
    };
    Sdk.prototype._saveData = function (name, value) {
        var propertyStorage = this._propertyStorage;
        if (propertyStorage) {
            propertyStorage.setProperty(name, value);
        }
        else {
            // Expires in 365 days
            setCookie(name, value, 365);
        }
    };
    Sdk.prototype._getData = function (name) {
        if (this._propertyStorage) {
            return this._propertyStorage.getProperty(name) || "";
        }
        else {
            return getCookie(name);
        }
    };
    return Sdk;
}());
export { Sdk };
//# sourceMappingURL=Sdk.js.map